// extracted by mini-css-extract-plugin
export default {"container":"DevDailyJoke_container__TdZCr","title":"DevDailyJoke_title__bfRIW","paragraph":"DevDailyJoke_paragraph__0e6Rw","subtitle":"DevDailyJoke_subtitle__lrArF"};